import { useCallback, useEffect, useRef, useState } from 'react';
import { masterclassApi, errorMessage } from './api';

export const useMasterclassVisuals = (classId, admin = false) => {
  const [catalog, setCatalog] = useState(null);
  const [error, setError] = useState('');
  const active = useRef(true);
  const inFlight = useRef(null);
  const endpoint = `/${admin ? 'admin/' : ''}masterclasses/${classId}/visuals`;
  const currentEndpoint = useRef(endpoint);
  currentEndpoint.current = endpoint;
  const refresh = useCallback(async () => {
    if (!classId || inFlight.current === endpoint) return;
    inFlight.current = endpoint;
    try {
      const { data } = await masterclassApi.get(endpoint);
      if (active.current && currentEndpoint.current === endpoint) { setCatalog(data); setError(''); }
    } catch (err) { if (active.current && currentEndpoint.current === endpoint) setError(errorMessage(err)); }
    finally { if (inFlight.current === endpoint) inFlight.current = null; }
  }, [classId, endpoint]);
  useEffect(() => {
    active.current = true; setCatalog(null); setError(''); refresh();
    return () => { active.current = false; };
  }, [refresh]);
  const pending = catalog?.items.some(item => ['queued', 'generating'].includes(item.status));
  useEffect(() => {
    if (!pending) return;
    const timer = setInterval(refresh, 5000);
    return () => clearInterval(timer);
  }, [pending, refresh]);
  return { catalog, error, refresh, endpoint };
};